var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTg = function SvgTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.324,
    r: 17.5,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.733 13.085c.156-1.007-.801-1.801-1.697-1.408l-17.83 7.828c-.642.282-.595 1.255.07 1.467l3.678 1.17a2.37 2.37 0 0 0 2.074-.315l8.29-5.727c.25-.173.523.182.31.402l-5.968 6.153c-.579.597-.464 1.608.232 2.045l6.682 4.19c.75.47 1.713-.003 1.853-.908z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    x2: 20,
    y1: 2.824,
    y2: 37.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DBB"
  })))));
};
export { SvgTg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MCA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMC4zMjQyIiByPSIxNy41IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNTE0Nl8xMzg5MCkiLz4KPHBhdGggZD0iTTI4LjczMzIgMTMuMDg1MkMyOC44ODkxIDEyLjA3ODQgMjcuOTMxOCAxMS4yODM3IDI3LjAzNjUgMTEuNjc2N0w5LjIwNjAyIDE5LjUwNTNDOC41NjQwNCAxOS43ODcxIDguNjExIDIwLjc1OTUgOS4yNzY4MyAyMC45NzE2TDEyLjk1MzkgMjIuMTQyNkMxMy42NTU3IDIyLjM2NjEgMTQuNDE1NyAyMi4yNTA1IDE1LjAyODUgMjEuODI3MUwyMy4zMTg3IDE2LjA5OTZDMjMuNTY4NyAxNS45MjY4IDIzLjg0MTIgMTYuMjgyMyAyMy42Mjc2IDE2LjUwMjVMMTcuNjYwMSAyMi42NTVDMTcuMDgxMyAyMy4yNTE5IDE3LjE5NjIgMjQuMjYzMiAxNy44OTI1IDI0LjY5OThMMjQuNTczNyAyOC44ODk2QzI1LjMyMzEgMjkuMzU5NSAyNi4yODcxIDI4Ljg4NzQgMjYuNDI3MyAyNy45ODE5TDI4LjczMzIgMTMuMDg1MloiIGZpbGw9IndoaXRlIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNTE0Nl8xMzg5MCIgeDE9IjIwIiB5MT0iMi44MjQyMiIgeDI9IjIwIiB5Mj0iMzcuODI0MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzdCQkZFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwN0RCQiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";